export default "__VITE_PUBLIC_ASSET__cda03b9d__"